var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobile = function SvgMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.604,
    height: 36.947
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19.604,
    height: 35.947,
    rx: 4,
    fill: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.642A2.641 2.641 0 0 1 2.639 0h14.326A2.64 2.64 0 0 1 19.6 2.642V34.3a2.641 2.641 0 0 1-2.639 2.642H2.639A2.64 2.64 0 0 1 0 34.3Zm1.131 0v31.667a1.51 1.51 0 0 0 1.508 1.507h14.326a1.507 1.507 0 0 0 1.508-1.507V2.638a1.508 1.508 0 0 0-1.507-1.507h-2.638a.747.747 0 0 0-.573.324l-.742 1.237a.744.744 0 0 1-.571.324H7.163a.74.74 0 0 1-.571-.324L5.85 1.455a.744.744 0 0 0-.573-.324H2.638a1.508 1.508 0 0 0-1.507 1.507Z",
    fill: "#2a4d4f",
    fillRule: "evenodd"
  })));
};
export default SvgMobile;